import type { SoloRunState, SceneDef } from '@plotjack/core';
import { canPlayCard, getCardById, cardBeatCompatible } from '@plotjack/core';
import type { StoryPack } from '@plotjack/core';

export function playDisabledMessage(reason?: string): string {
  switch (reason) {
    case 'no_energy':
      return 'Not enough Ink for this card.';
    case 'beat_mismatch':
      return 'This card does not fit the selected target.';
    case 'not_in_hand':
      return 'That card is not in your hand.';
    case 'unknown_beat':
      return 'Pick a story target first.';
    case 'unknown_card':
      return 'Unknown card.';
    case 'wrong_phase':
      return 'You cannot play cards right now.';
    default:
      return 'Select a card and a target to play.';
  }
}

export function hasPlayableCard(state: SoloRunState, scene: SceneDef, _story: StoryPack): boolean {
  if (state.phase !== 'scene_play' || state.energy <= 0) return false;
  for (const cardId of state.hand) {
    const card = getCardById(cardId);
    if (!card || card.cost > state.energy) continue;
    for (const beat of scene.beats) {
      if (cardBeatCompatible(card, beat)) return true;
    }
  }
  return false;
}

export function firstCompatibleBeatIndex(
  scene: SceneDef,
  cardId: string,
): number {
  const card = getCardById(cardId);
  if (!card) return 0;
  const idx = scene.beats.findIndex((b) => cardBeatCompatible(card, b));
  return idx >= 0 ? idx : 0;
}

export function evaluatePlay(
  state: SoloRunState,
  _scene: SceneDef,
  story: StoryPack,
  cardId: string | null,
  beatId: string | null,
): { ok: boolean; reason?: string } {
  if (!cardId) return { ok: false, reason: undefined };
  if (!beatId) return { ok: false, reason: 'unknown_beat' };
  return canPlayCard(state, cardId, beatId, story);
}
